import { hasContentInHTMLTags } from 'src/app/common/function';
import { PluginKey } from 'prosemirror-state';
import { isNodeActive } from 'ngx-editor/helpers';
import { EditorView } from 'prosemirror-view';
import { setBlockType } from 'prosemirror-commands';
import { Schema } from 'prosemirror-model';
import { ArticleBlock } from '../../../../models/article';
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, Renderer2, ElementRef, AfterViewChecked, AfterViewInit, OnChanges } from '@angular/core';
import { nodes as baseNodes, Editor, Toolbar, marks as baseMarks } from 'ngx-editor';

@Component({
  selector: 'app-article-header',
  templateUrl: './article-header.component.html',
  styleUrls: ['./article-header.component.scss']
})
export class ArticleHeaderComponent implements OnInit, OnDestroy, OnChanges {
  @Output() blockElementChange = new EventEmitter<ArticleBlock>();
  @Input() blockElement: ArticleBlock;
  editor: Editor;

  constructor(private renderer: Renderer2, private el: ElementRef) { }
  schema = new Schema({
    nodes: {
      doc: { content: 'block+' },
      heading: {
        ...baseNodes.heading,
        attrs: {
          ...baseNodes.heading.attrs,
          level: {default: 1}
        }
      },
      paragraph: baseNodes.paragraph,
      text: baseNodes.text
    },
    marks: baseMarks
  });

  ngOnInit(): void {
    this.editor = new Editor({
      schema: this.schema,
    });
  }

  ngOnChanges(): void {
    setTimeout(() => {
      if (this.blockElement?.isActiveForEdit) {
        const editorElement = this.el.nativeElement.querySelector('.ProseMirror.NgxEditor__Content');
        if (editorElement) {
          this.renderer.setAttribute(editorElement, 'autofocus', 'true');
          editorElement.focus();

          const { state, dispatch } = this.editor.view;
          const isAlreadyHeading = state.selection.$from.parent.type === this.schema.nodes.heading;
          if (!isAlreadyHeading) {
            setBlockType(this.schema.nodes['heading'], {level : 1})(state, dispatch);
          }
        }
      }
    }, 700);
  }

  onChange(e: string) {
    const { state, dispatch } = this.editor.view;
    setBlockType(this.schema.nodes['heading'])(state, dispatch);
    this.blockElement.data = e;
    this.blockElementChange.emit(this.blockElement);
  }

  ngOnDestroy(): void {
    this.editor.destroy();
  }
}
